"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUserContentSelector = exports.deleteAllContentSelector = exports.deleteUserData = exports.countUserDataToDelete = exports.deleteAllContent = exports.cancelContentDeletion = exports.fetchDeleteAllContentStatus = exports.countNbrOfDocumentForUserFailure = exports.countNbrOfDocumentForUserSuccess = exports.countNbrOfDocumentForUser = exports.submitDeleteUserFailure = exports.submitDeleteUserSuccess = exports.submitDeleteUser = exports.getDeleteAllContentStatusFailure = exports.getDeleteAllContentStatusSuccess = exports.getDeleteAllContentStatus = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var notifier_1 = __importDefault(require("@utils/notifier"));
var i18next_1 = __importDefault(require("i18next"));
var apiService_1 = __importDefault(require("@common/services/apiService"));
var initialState = {
    deleteAll: {
        deleteJobs: [],
        status: {
            loading: true,
            error: null,
        },
    },
    deleteUser: {
        documentCount: 0,
        status: {
            loading: true,
            error: null,
        },
    },
};
var deleteContentSlice = (0, toolkit_1.createSlice)({
    name: 'deleteAllContent',
    initialState: initialState,
    reducers: {
        getDeleteAllContentStatus: function (state) {
            state.deleteAll.status.loading = true;
        },
        getDeleteAllContentStatusSuccess: function (state, resp) {
            state.deleteAll.status.loading = false;
            state.deleteAll.deleteJobs = resp.payload;
        },
        getDeleteAllContentStatusFailure: function (state, _a) {
            var payload = _a.payload;
            state.deleteAll.status.loading = false;
            state.deleteAll.status.error = payload;
        },
        submitDeleteUser: function (state) {
            state.deleteUser.status.loading = true;
        },
        submitDeleteUserSuccess: function (state) {
            state.deleteUser.status.loading = false;
        },
        submitDeleteUserFailure: function (state, _a) {
            var payload = _a.payload;
            state.deleteUser.status.loading = false;
            state.deleteUser.status.error = payload;
        },
        countNbrOfDocumentForUser: function (state) {
            state.deleteUser.status.loading = true;
        },
        countNbrOfDocumentForUserSuccess: function (state, resp) {
            state.deleteUser.status.loading = false;
            state.deleteUser.status.error = null;
            state.deleteUser.documentCount = resp.payload.count;
        },
        countNbrOfDocumentForUserFailure: function (state, _a) {
            var payload = _a.payload;
            state.deleteUser.status.loading = false;
            state.deleteUser.status.error = payload;
        },
    },
});
exports.getDeleteAllContentStatus = (_a = deleteContentSlice.actions, _a.getDeleteAllContentStatus), exports.getDeleteAllContentStatusSuccess = _a.getDeleteAllContentStatusSuccess, exports.getDeleteAllContentStatusFailure = _a.getDeleteAllContentStatusFailure, exports.submitDeleteUser = _a.submitDeleteUser, exports.submitDeleteUserSuccess = _a.submitDeleteUserSuccess, exports.submitDeleteUserFailure = _a.submitDeleteUserFailure, exports.countNbrOfDocumentForUser = _a.countNbrOfDocumentForUser, exports.countNbrOfDocumentForUserSuccess = _a.countNbrOfDocumentForUserSuccess, exports.countNbrOfDocumentForUserFailure = _a.countNbrOfDocumentForUserFailure;
var fetchDeleteAllContentStatus = function (domain) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var data, ongoingJobs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getDeleteAllContentStatus)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.getSiteContentDeletionJobs({ domain: domain })];
                case 2:
                    data = (_a.sent()).data;
                    ongoingJobs = data.filter(function (job) { return job.type === 'ALL_DATA' && (job.state === 'READY' || job.state === 'IN_PROGRESS'); });
                    if (ongoingJobs.length > 1) {
                        dispatch((0, exports.getDeleteAllContentStatusFailure)('There are more than one ongoing jobs'));
                    }
                    dispatch((0, exports.getDeleteAllContentStatusSuccess)(ongoingJobs));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    notifier_1.default.error(i18next_1.default.t('settings:FAILED_TO_LOAD_SETTINGS_MESSAGE'));
                    if (err_1 instanceof Error) {
                        dispatch((0, exports.getDeleteAllContentStatusFailure)(err_1.message));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.fetchDeleteAllContentStatus = fetchDeleteAllContentStatus;
var cancelContentDeletion = function (domain, jobId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getDeleteAllContentStatus)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.deleteSiteContentDeletionJobs({ domain: domain, jobId: jobId })];
                case 2:
                    _a.sent();
                    notifier_1.default.success(i18next_1.default.t('settings:DELETE_ALL_CONTENT.CANCEL_DELETION_SUCCESS'));
                    dispatch((0, exports.getDeleteAllContentStatusSuccess)([]));
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    notifier_1.default.error(i18next_1.default.t('settings:DELETE_ALL_CONTENT.CANCEL_DELETION_FAILURE'));
                    if (err_2 instanceof Error) {
                        dispatch((0, exports.getDeleteAllContentStatusFailure)(err_2.message));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.cancelContentDeletion = cancelContentDeletion;
var deleteAllContent = function (domain, timeZone) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.getDeleteAllContentStatus)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiService_1.default.postSiteContentDeletionJobs({ domain: domain }, { timeZone: timeZone })];
                case 2:
                    _a.sent();
                    notifier_1.default.success(i18next_1.default.t('settings:DELETE_ALL_CONTENT.SCHEDULE_DELETION_SUCCESS'));
                    return [4 /*yield*/, Promise.resolve()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_3 = _a.sent();
                    if (err_3 instanceof Error) {
                        notifier_1.default.error("i18n.t('settings:DELETE_ALL_CONTENT.CANCEL_DELETION_FAILURE') ".concat(err_3.message));
                        dispatch((0, exports.getDeleteAllContentStatusFailure)(err_3.message));
                    }
                    Promise.reject(err_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
exports.deleteAllContent = deleteAllContent;
var countUserDataToDelete = function (domain, userId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var nbrOfDoc, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.countNbrOfDocumentForUser)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.getDocumentsCount({ domain: domain, query: "document.user.id:".concat(userId) })];
                case 2:
                    nbrOfDoc = _a.sent();
                    dispatch((0, exports.countNbrOfDocumentForUserSuccess)(nbrOfDoc.data));
                    return [3 /*break*/, 4];
                case 3:
                    err_4 = _a.sent();
                    if (err_4 instanceof Error) {
                        notifier_1.default.error("i18n.t('settings:RIGHT_TO_BE_FORGOTTEN.DELETE_USER_DATA_FAILURE') ".concat(err_4.message));
                        dispatch((0, exports.countNbrOfDocumentForUserFailure)(err_4.message));
                    }
                    Promise.reject(err_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.countUserDataToDelete = countUserDataToDelete;
var deleteUserData = function (domain, username) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch((0, exports.submitDeleteUser)());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.postUserContentDeletionJobs({ domain: domain }, { deletion_user_id: username })];
                case 2:
                    _a.sent();
                    notifier_1.default.success(i18next_1.default.t('settings:RIGHT_TO_BE_FORGOTTEN.DELETE_USER_DATA_SUCCESS'));
                    dispatch((0, exports.submitDeleteUserSuccess)());
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    if (err_5 instanceof Error) {
                        notifier_1.default.error("i18n.t('settings:RIGHT_TO_BE_FORGOTTEN.DELETE_USER_DATA_FAILURE') ".concat(err_5.message));
                        dispatch((0, exports.submitDeleteUserFailure)(err_5.message));
                    }
                    Promise.reject(err_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.deleteUserData = deleteUserData;
var deleteAllContentSelector = function (state) { return state.currentTeam.settings.deleteContent.deleteAll; };
exports.deleteAllContentSelector = deleteAllContentSelector;
var deleteUserContentSelector = function (state) { return state.currentTeam.settings.deleteContent.deleteUser; };
exports.deleteUserContentSelector = deleteUserContentSelector;
exports.default = deleteContentSlice.reducer;
